// extracted by mini-css-extract-plugin
export default {"button":"CompleteProfile_button__M27kt"};